import { createReducer } from './reducer-factory';

const initialState = {
    pending: false,
    meals: [],
    recentmeals: [],
    mealsFromQuery:[],
    ingredientQuery:null,
    error: null
}
const strategies = {
    FETCH_MEALS_ERROR: fetchMealsErrorTransformer,
    FETCH_MEALS_PENDING: fetchMealsPendingTransformer,
    FETCH_MEALS_SUCCESS: fetchMealsSuccessTransformer,
    FETCH_MEAL_QUERY_SUCCESS: fetchMealQuerySuccessTransformer,
    FETCH_RECENTMEALS_SUCCESS: fetchRecentMealsSuccessTransformer,
    ADD_MEAL_SUCCESS: addMealSuccessTransformer,
    UPDATE_MEAL_SUCCESS: updateMealSuccessTransformer,
    REMOVE_MEAL_SUCCESS: removeMealSuccessTransformer,
};
const mealsList = createReducer(initialState, strategies);

function fetchMealsErrorTransformer(state, action) {
    return { ...state, pending: false, error: action.error};
}
function fetchMealsPendingTransformer(state) {
    return { ...state, pending: true };
}
function fetchMealsSuccessTransformer(state, action) {
    return { ...state, pending: false, meals: action.meals.data };
}
function fetchMealQuerySuccessTransformer(state, action) {
    return { ...state, pending: false, mealsFromQuery: action.meals.data , ingredientQuery: action.query};
}
function fetchRecentMealsSuccessTransformer(state, action) {
    return { ...state, pending: false, recentmeals: action.recentmeals.data };
}
function addMealSuccessTransformer (state, action){
    let currentMeals = state.meals;
    currentMeals.push(action.meal);

    return { ...state, pending: false, meals: currentMeals };
}
function updateMealSuccessTransformer (state, action){
    let currentMeals = state.meals.filter(wi=>wi._id.toString() !== action.id.toString());
    currentMeals.push({
        ...action.meal,
        _id: action.id
    });
    return { ...state, pending: false, meals: currentMeals };
}
function removeMealSuccessTransformer (state, action){
    let currentMeals = state.meals.filter(wi=>wi._id.toString() !== action.id.toString());
    return { ...state, pending: false, meals: currentMeals };
}

export default mealsList

export const getMeals = state => state.mealsList.meals;
export const getMealsFromQuery = state => state.mealsList.mealsFromQuery;
export const getMealQuery = state => state.mealsList.ingredientQuery;
export const getRecentMeals = state => state.mealsList.recentmeals;
export const getMealsPending = state => state.mealsList.pending;
export const getMealsError = state => state.mealsList.error;

